module.exports = __webpack_public_path__ + "static/media/your-turn-2.fc1ead92.mp3";